<!--163번 템플릿에서 사용됨-->
<template>
  <div class="mt-component-form">
    <!-- PC 레이아웃 (768px 이상) -->
    <div class="desktop-layout" v-show="!isMobile">
      <vs-row class="my-4 center-flex">
        <h5><i class="dot"></i>{{ this.title }}</h5>
        <div class="ml-auto">
          <vs-button
            v-if="!isPrint && !isReadonly"
            class=""
            color="secondary"
            type="border"
            @click="handleAddRow"
            >항목추가</vs-button
          >
          <vs-button
            v-if="!isPrint && !isReadonly"
            class="ml-4"
            color="secondary"
            @click="handleRemoveRow"
            >선택삭제</vs-button
          >
        </div>
      </vs-row>

      <div
        class="grid row-header"
        :class="[isPrint || isReadonly? ' grid-cols-10' : ' grid-cols-11']"
      >
        <div v-if="!isPrint && !isReadonly" class="col-span-1 row-header__item">
          <vs-checkbox
            v-model="equipAllCheck"
            @change="changeAllCheck"
          ></vs-checkbox>
        </div>
        <div class="col-span-2 row-header__item">점검장소</div>
        <div class="col-span-2 row-header__item">업체명</div>
        <div class="col-span-2 row-header__item">주요작업</div>
        <div class="col-span-2 row-header__item">점검내용</div>
        <div class="col-span-2 row-header__item">재해형태</div>
      </div>
      <!-- rows -->
      <div
        class="grid row-content"
        :class="[isPrint || isReadonly ? ' grid-cols-10' : ' grid-cols-11']"
        v-for="(rows, indexRows) in equipmentList"
        :key="indexRows"
      >
        <div v-if="!isPrint && !isReadonly" class="col-span-1 none-border-center">
          <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
        </div>
        <div class="col-span-2 item-area textarea-container">
          <ml-input
            v-if="!isPrint"
            rows="1"
            v-model="rows.name"
            class="w-full flex-1 p-1"
            placeholder="입력"
            :readonly="isReadonly"
          />
          <span v-else class="print-input"> {{ rows.name }}</span>
        </div>
        <div class="col-span-2 item-area textarea-container">
          <CompanySelector
            v-if="!isPrint"
            v-model="rows.company"
            class="w-full flex-1"
            :readonly="isReadonly"
          />
          <span v-else class="print-input">{{ rows.company }}</span>
        </div>
        <div class="col-span-2 item-area textarea-container">
          <ml-textarea
            v-if="!isPrint"
            height="90px"
            v-model="rows.primary"
            class="w-full flex-1 p-1 resize-stop"
            placeholder="입력"
            :readonly="isReadonly"
          />
          <span v-else class="print-textarea">{{ rows.primary }}</span>
        </div>
        <div class="col-span-2 item-area textarea-container">
          <ml-textarea
            v-if="!isPrint"
            height="90px"
            v-model="rows.body"
            class="w-full flex-1 p-1 resize-stop"
            placeholder="입력"
            :readonly="isReadonly"
          />
          <span v-else class="print-textarea">{{ rows.body }}</span>
        </div>
        <div class="col-span-2 item-area textarea-container" :style="{color: disasterColor}">
          <DisasterClassSelector
            v-if="!isPrint"
            class="w-full"
            v-model="rows.disaster"
            :readonly="isReadonly"
            @input="updateList"
          />
          <span v-else class="print-input">{{ rows.disaster }}</span>
        </div>
      </div>
    </div>

    <!-- 모바일 레이아웃 (768px 미만) -->
    <div class="mobile-layout" v-show="isMobile">
      <!-- 모바일 헤더 -->
      <div class="mobile-header">
        <h5 class="mobile-title"><i class="dot"></i> {{ title }}</h5>

        <!-- 전체 선택 영역 -->
        <div v-if="!isPrint && !isReadonly && equipmentList.length > 0" class="mobile-select-all">
          <vs-checkbox
            v-model="equipAllCheck"
            @change="changeAllCheck"
            class="mobile-checkbox"
          />
          <span class="select-all-text">전체 선택 ({{ checkedCount }}/{{ equipmentList.length }})</span>
          <vs-button
            v-if="equipAllCheck && checkedCount === equipmentList.length"
            color="danger"
            type="border"
            size="small"
            @click="handleDeleteAll"
            class="mobile-delete-all-btn"
          >
            전체삭제
          </vs-button>
        </div>
      </div>

      <!-- 빈 목록 표시 -->
      <div v-if="equipmentList.length === 0" class="mobile-empty-card">
        <feather-icon icon="InfoIcon" />
        <p class="empty-text">{{ title }} 항목이 존재하지 않습니다.</p>
      </div>

      <!-- 모바일 카드 목록 -->
      <div v-else class="mobile-cards-container">
        <div v-for="(item, index) in equipmentList" :key="index" class="mobile-card">
          <!-- 카드 헤더 -->
          <div class="mobile-card-header">
            <vs-checkbox v-if="!isPrint && !isReadonly" v-model="item.is_checked" class="mobile-checkbox" />
            <span class="card-number">항목 {{ index + 1 }}</span>
            <vs-button v-if="!isPrint && !isReadonly" color="danger" type="border" size="small" @click="handleRemoveSingleRow(index)" class="mobile-delete-btn"> 삭제 </vs-button>
          </div>

          <!-- 점검장소 -->
          <div class="mobile-field">
            <label class="mobile-label">점검장소</label>
            <div class="mobile-input-container">
              <p v-if="isPrint" class="mobile-print-text">{{ item.name }}</p>
              <ml-input v-else :readonly="isReadonly" v-model="item.name" placeholder="입력" class="mobile-input" />
            </div>
          </div>

          <!-- 업체명 -->
          <div class="mobile-field">
            <label class="mobile-label">업체명</label>
            <div class="mobile-input-container">
              <p v-if="isPrint" class="mobile-print-text">{{ item.company }}</p>
              <CompanySelector v-else v-model="item.company" :readonly="isReadonly" class="mobile-input" />
            </div>
          </div>

          <!-- 주요작업 -->
          <div class="mobile-field">
            <label class="mobile-label">주요작업</label>
            <div class="mobile-input-container">
              <p v-if="isPrint" class="mobile-print-text">{{ item.primary }}</p>
              <ml-textarea v-else :readonly="isReadonly" v-model="item.primary" rows="3" placeholder="입력" class="mobile-textarea" />
            </div>
          </div>

          <!-- 점검내용 -->
          <div class="mobile-field">
            <label class="mobile-label">점검내용</label>
            <div class="mobile-input-container">
              <p v-if="isPrint" class="mobile-print-text">{{ item.body }}</p>
              <ml-textarea v-else :readonly="isReadonly" v-model="item.body" rows="3" placeholder="입력" class="mobile-textarea" />
            </div>
          </div>

          <!-- 재해형태 -->
          <div class="mobile-field">
            <label class="mobile-label">재해형태</label>
            <div class="mobile-input-container">
              <p v-if="isPrint" class="mobile-print-text" :style="{color: disasterColor}">{{ item.disaster }}</p>
              <DisasterClassSelector v-else v-model="item.disaster" :readonly="isReadonly" @input="updateList" class="mobile-input" />
            </div>
          </div>
        </div>
      </div>

      <!-- 모바일 하단 버튼 -->
      <div v-if="!isPrint && !isReadonly" class="mobile-bottom-actions">
        <vs-button color="danger" type="border" :disabled="checkedCount === 0" @click="handleRemoveRow" class="mobile-action-btn"> 선택삭제 ({{ checkedCount }}) </vs-button>
        <vs-button color="primary" @click="handleAddRow" class="mobile-action-btn mobile-add-btn"> 항목추가 </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";
export default {
  name: "InspectionInfoList",
  components: { CompanySelector, DisasterClassSelector },
  props: {
    title: String,
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
    disasterColor: {
      type: String,
      default: '#3c3c3c'
    },
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.equipmentList = value;
        }
      },
    },
    // 개별 체크박스 상태 변경 감지
    equipmentList: {
      deep: true,
      handler(newList) {
        // 전체 선택이 체크되어 있는 상태에서 개별 항목이 해제되면 전체 선택도 해제
        if (this.equipAllCheck) {
          const allChecked = newList.every(item => item.is_checked);
          if (!allChecked) {
            this.equipAllCheck = false;
          }
        }
      }
    }
  },
  methods: {
    checkForm(value, indexRows, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", indexRows - 1, text);
      } else {
        this.$emit("update-list-check", indexRows - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      this.equipmentList.push({
        is_checked: this.equipAllCheck,
        name: "",
        manufacturer: "",
        standard: "",
      });
      this.updateList();
    },
    // 선택삭제
    handleRemoveRow() {
      for (let i = 0; i < this.equipmentList.length; i++) {
        if (this.equipmentList[i].is_checked) {
          this.equipmentList.remove(this.equipmentList[i]);
          i = -1;
        }
      }

      this.equipAllCheck = false;
      this.updateList();
    },
    // 개별 항목 삭제 (모바일용)
    handleRemoveSingleRow(index) {
      this.equipmentList.splice(index, 1);
      this.updateList();
    },
    // 전체삭제
    handleDeleteAll() {
      this.equipmentList = [];
      this.equipAllCheck = false;
      this.updateList();
    },
    // 일괄 체크
    changeAllCheck() {
      for (const data of this.equipmentList) {
        data.is_checked = this.equipAllCheck;
      }
    },
    // update
    updateList() {
      this.$emit("updateList", this.equipmentList);
    },
  },
  data() {
    return {
      equipAllCheck: false,
      equipmentList: [],
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
    checkedCount() {
      return this.equipmentList.filter(item => item.is_checked).length;
    },
  },
  mounted() {
    // 화면 크기 변경 감지
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border-top: $border;
  border-bottom: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
.textarea-container {
  padding: 0.25rem !important;
}
.resize-stop textarea {
  resize: none !important;
}

// 모바일 레이아웃 스타일
@media (max-width: 767px) {
  .desktop-layout {
    display: none !important;
  }
}

@media (min-width: 768px) {
  .mobile-layout {
    display: none !important;
  }
}

.mobile-layout {
  .mobile-header {
    margin-bottom: 16px;

    .mobile-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 12px;
      color: #333;

      .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #007bff;
        border-radius: 50%;
        margin-right: 8px;
      }
    }

    .mobile-select-all {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      background: #f8f9fa;
      border-radius: 8px;
      border: 1px solid #e9ecef;

      .mobile-checkbox {
        margin-right: 12px;
        justify-content: center !important;

        &::v-deep span {
          margin: 0;
        }
      }

      .select-all-text {
        flex: 1;
        font-size: 14px;
        color: #666;
        font-weight: 500;
      }

      .mobile-delete-all-btn {
        min-height: 32px;
        font-size: 12px;
        padding: 6px 12px;
        margin-left: 8px;
      }
    }
  }

  .mobile-empty-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background: #fafafa;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    text-align: center;

    .empty-icon {
      width: 48px;
      height: 48px;
      color: #999;
      margin-bottom: 16px;
    }

    .empty-text {
      color: #999;
      font-size: 16px;
      margin: 0;
    }
  }

  .mobile-cards-container {
    .mobile-card {
      background: white;
      border: 1px solid #e9ecef;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 16px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      .mobile-card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e9ecef;

        .mobile-checkbox {
          margin-right: 12px;
          justify-content: center !important;

          &::v-deep span {
            margin: 0;
          }
        }

        .card-number {
          flex: 1;
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }

        .mobile-delete-btn {
          min-height: 32px;
          font-size: 12px;
          padding: 6px 12px;
        }
      }

      .mobile-field {
        margin-bottom: 16px;

        .mobile-label {
          display: block;
          font-size: 13px;
          font-weight: 600;
          color: #333;
          margin-bottom: 6px;
        }

        .mobile-input-container {
          .mobile-print-text {
            font-size: 14px;
            color: #555;
            line-height: 1.5;
            margin: 0;
            word-break: break-word;
          }

          .mobile-textarea,
          .mobile-input {
            width: 100%;
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .mobile-bottom-actions {
    display: flex;
    gap: 12px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    margin-top: 16px;

    .mobile-action-btn {
      flex: 1;
      min-height: 44px;
      font-size: 14px;
      font-weight: 600;

      &.mobile-add-btn {
        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
        color: white;
        border: none;
      }
    }
  }
}
</style>
